module.exports = __webpack_public_path__ + "img/play4k.27b90cf7.png";